import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import Header from '../common/template/header';
import SideBar from '../common/template/sideBar';
import Footer from '../common/template/footer';
import Messages from '../common/msg/messages';
import imagemLogo from '../assets/images/logo_branca_vermelha.png';

import Routes from './routes';
import MenuPortal from '../menuPortal/menuPortal';
import MenuPerfilAcesso from '../menuPerfilAcesso/menuPerfilAcesso';
import RoutesPerfilAcesso from './routesPerfilAcesso';
import { getListaMenu } from '../menuPerfilAcesso/menuPerfilAcessoActions';
import SideBarPerfilAcesso from '../common/template/sideBarPerfilAcesso';

class App extends Component {

	state = {
		carregando: true
	}

	constructor(props) {
		super(props);
		
		setTimeout(() => {
			this.setState({ ...this.state, carregando: false })
			this.props.getListaMenu();
		}, 2000);
    }

	render() {

		const novoPerfilAcesso = this.props.usuarioCarregado && (this.props.usuarioCarregado.ids_perfil_acesso || []).length > 0;
		
		return (
			<HashRouter>
				{(this.state.carregando || !this.props.usuarioCarregado) ? (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							backgroundColor: '#1f3269',
							height: '100vh',
							opacity: this.state.opacity,
							transition: 'opacity 1.5s ease-in-out'
						}}>
						<img src={imagemLogo} style={{ height: 'auto', maxWidth: 300, width: window.innerWidth - 40, marginBottom: 32 }} />

						<div style={{ color: '#ffffff', fontSize: 18, marginBottom: 8 }}>SIGA NOSSAS REDES SOCIAIS!</div>

						<div style={{ color: '#ffffff', fontSize: 20, fontWeight: 'bold', marginBottom: 16 }}>@letsaralogistica</div>

						<div>
							<i style={{ color: '#ffffff', fontSize: 42 }} class='fab fa-facebook-square'></i>

							<i style={{ color: '#ffffff', fontSize: 42, marginLeft: 16, marginRight: 16 }}  class='fab fa-instagram-square'></i>

							<i style={{ color: '#ffffff', fontSize: 42 }}  class='fab fa-linkedin'></i>
						</div>
					</div>
				) : (window.location.hash == '#/' 
					&& this.props.usuarioCarregado && (this.props.usuarioCarregado.ids_perfil_acesso || []).length ? (
					<div>
						<MenuPerfilAcesso />
					</div>
				
				) : (false && window.location.hash == '#/' 
					&& this.props.usuarioCarregado && [1, 27, 63].includes(this.props.sessao.id) ? (
					<div>
						<MenuPortal />
					</div>
				) : (
					<div className='wrapper'>
						<Header />
						{novoPerfilAcesso 
							? <SideBarPerfilAcesso />
							: <SideBar />}
						{novoPerfilAcesso 
							? <RoutesPerfilAcesso usuarioCarregado={this.props.usuarioCarregado} listaMenu={this.props.listaMenu} />
							: <Routes usuarioCarregado={this.props.usuarioCarregado} />}
						<Messages />
					</div>
				)))}
			</HashRouter>
		);
	}
}


const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	listaMenu: state.menuPerfilAcesso.listaMenu
});
const mapDispatchToProps = dispatch => bindActionCreators({ getListaMenu }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(App);
